import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentSession = this.authService.currentSessionValue;
        const authURL = /\/auth\//gi;

        if (request.url.search(authURL) === -1 && currentSession && currentSession.jwt) {

            const headerParams = {
                Authorization: `Bearer ${currentSession.jwt}`,
                userName: currentSession.username,
                'x-id': currentSession.username
            };

            if (currentSession.branchOffice) {
                headerParams['x-branchOffice'] = currentSession.branchOffice.toString();
            }

            request = request.clone({
                setHeaders: headerParams
            });
        }

        return next.handle(request);
    }

}
